import { useState, useMemo } from 'react';
import Pagination from '../components/ui/Pagination';

export const usePagination = (data, initialPageSize = 20) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(initialPageSize);

  const totalPages = useMemo(() => 
    Math.ceil(data.length / pageSize), [data.length, pageSize]
  );

  const paginatedData = useMemo(() => {
    const startIndex = (currentPage - 1) * pageSize;
    return data.slice(startIndex, startIndex + pageSize);
  }, [data, currentPage, pageSize]);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const resetToFirstPage = () => setCurrentPage(1);

  return {
    currentPage,
    totalPages,
    pageSize,
    paginatedData,
    handlePageChange,
    setPageSize,
    resetToFirstPage
  };
}; 

// Compatibility for reports that still call the original rendering helper.
export const paginationTableComponent = (currentPage, totalPages, handlePageChange, totalRecords) => (
  <Pagination
    currentPage={currentPage}
    totalPages={totalPages}
    onPageChange={handlePageChange}
    totalRecords={totalRecords}
    docked
  />
);
